export function unidadesInRequest(params = {}) {
  return {
    type: '@unidade/UNIDADES_IN_REQUEST',
    payload: { params },
  };
}

export function findUnidade(idunidade) {
  return {
    type: '@unidade/FIND_UNIDADE',
    payload: { idunidade },
  };
}

export function failedRequest() {
  return {
    type: '@unidade/FAILED_REQUEST',
  };
}

export function deleteUnidade(idunidade, params) {
  return {
    type: '@unidade/DELETE_UNIDADE',
    payload: { idunidade, params },
  };
}

export function updateUnidade(unidade, params) {
  return {
    type: '@unidade/UPDATE_UNIDADE',
    payload: { unidade, params },
  };
}

export function storeUnidade(unidade, params) {
  return {
    type: '@unidade/STORE_UNIDADE',
    payload: { unidade, params },
  };
}

export function successInRequest(
  unidades,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@unidade/SUCCESS_IN_REQUEST',
    payload: { unidades, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(unidade) {
  return {
    type: '@unidade/SUCCESS_REQUEST',
    payload: { unidade },
  };
}

export function successRemove(params) {
  return {
    type: '@unidade/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@unidade/RECORD_FILTERING',
    payload: { params },
  };
}
